<div class="flex-container" style="width: 100%">
  <div style="display: flex; flex-direction: column; flex-basis: 100%; flex: 1">

    <h2>The {{ this.transactionType!.toLowerCase() }} transaction was successful!</h2>

    <div style="margin-bottom: 20px">
      <div style="margin-bottom: 20px; padding-bottom: 10px; border-bottom: 1px solid #dddddd;" [hidden]="transaction == undefined">
        <div [innerHTML]="transactionDate | safeHtml: 'html'"></div>
        <div>Type: {{ transaction?.type }}</div>
        <div>Total: {{ transactionTotal }}</div>
        <div>
          {{ paymentMethod?.cardType }} {{ paymentMethod?.cardExpMonth }}/{{paymentMethod?.cardExpYear}}
        </div>
        <div>
          {{ paymentMethod?.cardFirst6 }}*****{{ paymentMethod?.cardLast4 }}
        </div>
      </div>

      <div [hidden]="order?.recurringSchedule?.period == null">
        <h4>Original order details:</h4>

        Recurring Sale<br />
        Every {{ order?.recurringSchedule?.periodCount }}
        {{ order?.recurringSchedule?.period }}
        starting on {{ order?.recurringSchedule?.firstChargeDate }}
        <div [hidden]="order?.recurringSchedule?.chargeUntil != 'cancelled'">until cancelled</div>
        <div [hidden]="order?.recurringSchedule?.finalChargeDate == null">
          and ending on {{ order?.recurringSchedule?.finalChargeDate }}
        </div>
      </div>
      <div>${{ order?.totalAmount }}</div>
      <div [innerHTML]="orderDate | safeHtml: 'html'"></div>
      <div>{{ order?.orderType }}</div>
      <div>{{ order?.customerFirst }} {{ order?.customerLast }}</div>
      <div>
        {{ order?.cardBrand }} {{ order?.cardExpMM }}/{{ order?.cardExpYY }}
      </div>
      <div>{{ order?.cardFirst6 }}*****{{ order?.cardLast4 }}</div>

      <!-- TODO: Add back in the list of transactions with better formatting -->
      <!-- <div [hidden]="order?.transactions == null || order?.transactions == 0">
                  [list of transactions]
              </div> -->

      <div [hidden]="order?.description == null || order?.description == ''">
        {{ order?.description }}
      </div>
    </div>

  </div>

    <div>
      <app-textbox [label]="'Email'" [type]="inputTextModes.Email" [defaultText]="order?.recipientEmail || ''" [(ngModel)]="customerEmail"></app-textbox>
      <br/>
      <input type="button" value="Send receipt to customer" class="primary" [disabled]="!customerEmail" (click)="handleSendToCustomer()"/>
    </div>

</div>
